document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('click', (e) => {
    const bundle_item = e.target.closest('.lineitem_bundle_item');
    if (bundle_item) {
      const qty = bundle_item.getAttribute('data_qty');
      const parent = bundle_item.closest('.line-item');
      const qty_input = parent.querySelector('.quantity-selector__input');

      if (qty_input) {
        qty_input.value = parseInt(qty);
        qty_input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    //---------------- Start - Produktbilder testen ----------------

    const pvideos_toggle = e.target.closest('.pvideos_toggle');
    if (pvideos_toggle) {
      const pvideos_wrapper = document.querySelector('.pvideos_list_wrapper');
      if (pvideos_wrapper) {
        pvideos_wrapper.classList.toggle('pvideos_wrapper_active');
      }
    }
    const pvideo_item = e.target.closest('.pvideo_item');
    if(pvideo_item){
      const popup_id = pvideo_item.getAttribute('popup');
      const popup = document.querySelector(`.pvideo_popup[popup="${popup_id}"]`);
      if(popup){
        const parent = popup.closest('.video_popups_main');
        parent.classList.add('video_popups_show');
        popup.classList.add('ppopup_show');
        const video = popup.querySelector('video');
        video.play();
      }
    }
    const video_overlay = e.target.closest('.video_popup_overlay');
    if(video_overlay){
      const video = document.querySelector('.ppopup_show video');
      const parent = video_overlay.closest('.video_popups_main');
      video.pause();
      parent.classList.remove('video_popups_show');
      document.querySelectorAll('.pvideo_popup').forEach(el => {
        el.classList.remove('ppopup_show');
      });
    }
    const video__close = e.target.closest('.video_popup_close');
    if(video__close){
      const video = document.querySelector('.ppopup_show video');
      const parent = video__close.closest('.video_popups_main');
      video.pause();
      parent.classList.remove('video_popups_show');
      document.querySelectorAll('.pvideo_popup').forEach(el => {
        el.classList.remove('ppopup_show');
      });
    }  
    //---------------- End - Produktbilder testen ----------------

  });
});


document.addEventListener('click', function(event) {
  const free_gift_btn = event.target.closest('.fgi-atc-btn');
  if (!free_gift_btn) return;

  const gift_id = parseInt(free_gift_btn.getAttribute('data-id'));
  if (!gift_id) return;

  free_gift_btn.setAttribute('disabled', true);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: gift_id,
          quantity: 1
        }
      ]
    })
  })
  .then(res => res.json())
  .then(cartData => {
    free_gift_btn.removeAttribute('disabled');

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: {
          cart: cartData,
          openMiniCart: true,
          replacementDelay: 0
        }
      })
    );
  })
  .catch(err => {
    free_gift_btn.removeAttribute('disabled');
    console.error("❌ Error adding bundle:", err);
  });
});

document.addEventListener('cart:refresh', function(event) {
  const mini_drawer = document.querySelector('#mini-cart');
  if (!mini_drawer) return;

  const freegift_id = parseInt(mini_drawer.getAttribute('data-freegift-id'));
  const freegift_count = parseInt(mini_drawer.getAttribute('data-freegift-count'));

  const cart = event.detail?.cart;
  if (!cart || !cart.items) return;

  const freeGiftItem = cart.items.find(item => item.variant_id == freegift_id);

  if (!freeGiftItem) return;

  if (cart.item_count < freegift_count) {

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {
          [freegift_id]: 0
        }
      })
    })
    .then(res => res.json())
    .then(updatedCart => {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: updatedCart,
            openMiniCart: true,
            replacementDelay: 0
          }
        })
      );
    })
    .catch(err => console.error('Free gift remove error:', err));
  }
});


